export default () => [
  {
    field: 'soBillCode',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'soBillNo',
    align: 'center',
    fixed: 'left',
    width: 50,
    type: 'checkbox',
  },
  {
    field: '',
    align: 'center',
    fixed: 'left',
    width: 50,
    slots: { default: 'box' },
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    slots: { default: 'opt' },
  },
  {
    field: 'brandNo',
    align: 'center',
    width: 130,
    title: '品牌',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'dmsOrderNo',
    align: 'center',
    width: 150,
    title: 'DMS订单号',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'v_txnType',
    align: 'center',
    width: 120,
    title: '交易类型',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'sellerPartyCode',
    align: 'center',
    width: 140,
    title: '售达方编号',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'sellerPartyName',
    align: 'center',
    width: 150,
    title: '售达方名称',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'servingPartyCode',
    align: 'center',
    width: 150,
    title: '运达方编号',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'servingPartyName',
    align: 'center',
    width: 160,
    title: '送达方名称',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    field: 'receiveAddress',
    title: '送货地址',
    headerAlign: 'center',
    align: 'center',
    minWidth: 280,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'receiveContactName',
    title: '收货联系人',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: true,
  },
  {
    field: 'receiveContactMobile',
    title: '收货联系人电话',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'receiveCityName',
    title: '送达城市',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
  },
  {
    field: 'orderDate',
    align: 'center',
    width: 120,
    title: '订单接收日期',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'orderSoNo',
    align: 'center',
    width: 130,
    title: '发货单号',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'weightDate',
    align: 'center',
    width: 100,
    title: '称重日期',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'weightDateTime',
    align: 'center',
    width: 100,
    title: '称重时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    field: 'pickDate',
    title: '出库日期',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
  },
  {
    field: 'pickupTime',
    align: 'center',
    width: 80,
    title: 'Pick-up',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'pickDatetime',
    title: '出库时间',
    headerAlign: 'center',
    align: 'center',
    width: 90,
    showHeaderOverflow: true,
  },
  {
    field: 'grossWeight',
    align: 'center',
    width: 120,
    title: '出库称重（KG）',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'volume',
    align: 'center',
    width: 120,
    title: '出库体积（m3）',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'volumeWeight',
    align: 'center',
    width: 150,
    title: '体积折算计费重量（KG）',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'chargeableWeight',
    title: '计费重量（KG）',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
  },
  {
    field: 'contractUnitPrice',
    align: 'center',
    width: 120,
    title: '单价（元/KG）',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'incomeFreightAmount',
    align: 'center',
    width: 120,
    title: '运输费用',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'contractMinAmount',
    align: 'center',
    width: 120,
    title: '零担最低收费（元/票）',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'vehicleUnloadingFee',
    align: 'center',
    width: 120,
    title: '整车卸货费',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'tallyFee',
    align: 'center',
    width: 120,
    title: '理货费',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'upstairsFee',
    align: 'center',
    width: 120,
    title: '上楼费',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'minusFee',
    align: 'center',
    width: 120,
    title: '减免费用',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'minusFee',
    },
  },
  {
    field: 'otherFee',
    align: 'center',
    width: 120,
    title: '其他额外费用',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'otherFee',
    },
  },
  {
    field: 'incomeTotalAmount',
    align: 'center',
    width: 120,
    title: '总费用（未税）',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'bigTrayCount',
    title: '大托',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    slots: {
      default: 'bigTrayCount',
    },
  },
  {
    field: 'smTrayCount',
    title: '小托',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    slots: {
      default: 'smTrayCount',
    },
  },
  {
    field: 'cartonCount',
    title: '箱数',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    slots: {
      default: 'cartonCount',
    },
  },
  {
    field: 'count',
    align: 'center',
    width: 100,
    title: '运输数量（托盘数+箱数）',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'count',
    },
  },
  {
    field: 'transportModeName',
    title: '运输方式',
    headerAlign: 'center',
    align: 'center',
    width: 95,
  },
  {
    field: 'carOne',
    title: '4.2M',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    field: 'carTwo',
    title: '7.6M',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    field: 'carThree',
    title: '9.6M',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    field: 'carFour',
    title: '14M',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    field: 'carFive',
    title: '17.5M',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    field: 'carCount',
    title: '车次',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    field: 'contractMoment',
    align: 'center',
    width: 100,
    title: '运输时限',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'expectArriveTime',
    title: '预计到达时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: true,
  },
  {
    field: 'actualArriveTime',
    title: '实际到达时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: true,
  },

  {
    field: 'dalayDays',
    align: 'center',
    width: 100,
    title: '迟到天数',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'delayReasonName',
    align: 'center',
    width: 150,
    title: '迟到原因名称',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'delayReasonCode',
    align: 'center',
    width: 150,
    title: '迟到原因代码',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'delayReasonDesc',
    align: 'center',
    width: 150,
    title: '迟到原因具体说明',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'actualDays',
    align: 'center',
    width: 100,
    title: '实际时长',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: '',
    align: 'center',
    width: 100,
    title: '备注',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: '',
    align: 'center',
    width: 100,
    title: '提货KPI备注',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'carrierName',
    align: 'center',
    width: 170,
    title: '供应商名称',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'contractCarrierName',
    title: '应付合同名称',
    headerAlign: 'center',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'payFreightAmount',
    title: '支出运费',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
  },
  {
    field: 'payCostAmount',
    title: '支出费用',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: true,
  },
  {
    field: 'payOtherCostAmount',
    title: '额外支出费用',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: true,
  },
  {
    field: 'contractCarrierMoment',
    title: '应付合同时效',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
  },

  {
    field: 'payAmount',
    title: '支出总价',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
  },
  {
    field: 'carOne',
    title: '4.2M',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    field: 'carTwo',
    title: '7.6M',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    field: 'carThree',
    title: '9.6M',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    field: 'carFour',
    title: '14M',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    field: 'carFive',
    title: '17.5M',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    field: 'carCount',
    title: '车次',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    field: 'builderTime',
    title: '生成时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: true,
  },
  {
    field: 'modifyTime',
    title: '修改时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyByName',
    title: '修改人',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
